export const modal_mix = {
  data() {
    return {
      showsettings: false,
    }
  },
  props: {

  },
  methods: {
    setShowsettings($event, isEdit = false, item = false) {
      //console.log(isEdit, item);
      this.isEdit = isEdit;
      this.edit_item = item;
      this.showsettings = !this.showsettings;
      if (this.showsettings) {
        $(document.body).addClass('fixed');
      } else {
        $(document.body).removeClass('fixed');
      }
    },
  }
};